import React from 'react'
import type { DetailedBlockchainTxnResponse } from '../../lib/api/generated/models'

/**
 * Props passed to artifact plugin components
 */
export interface ArtifactPluginProps {
  transaction: DetailedBlockchainTxnResponse
  onBack?: () => void
}

/**
 * Artifact plugin component type
 */
export type ArtifactPluginComponent = React.ComponentType<ArtifactPluginProps>

/**
 * Plugin registry entry
 */
interface ArtifactPlugin {
  artifactTypeId: string
  component: ArtifactPluginComponent
  name: string
  description?: string
}

/**
 * Registry for artifact-specific view plugins
 */
class ArtifactPluginRegistryClass {
  private plugins: Map<string, ArtifactPlugin> = new Map()

  /**
   * Register a plugin for a specific artifact type
   */
  register(plugin: ArtifactPlugin): void {
    this.plugins.set(plugin.artifactTypeId, plugin)
    console.log(`Registered artifact plugin: ${plugin.name} for artifact type ${plugin.artifactTypeId}`)
  }

  /**
   * Get plugin for a specific artifact type
   */
  getPlugin(artifactTypeId: string): ArtifactPluginComponent | null {
    const plugin = this.plugins.get(artifactTypeId)
    return plugin?.component || null
  }

  /**
   * Check if a plugin exists for an artifact type
   */
  hasPlugin(artifactTypeId: string): boolean {
    return this.plugins.has(artifactTypeId)
  }

  /**
   * Get all registered plugins
   */
  getAllPlugins(): ArtifactPlugin[] {
    return Array.from(this.plugins.values())
  }
}

// Export singleton instance
export const ArtifactPluginRegistry = new ArtifactPluginRegistryClass()
